import { useTranslation } from 'react-i18next';

/**
 * Props para ProjectFormFooter
 */
interface ProjectFormFooterProps {
  isEditMode: boolean;
  isLoading: boolean;
  onCancel: () => void;
}

/**
 * ProjectFormFooter - Footer con botones de acción
 *
 * @remarks
 * Incluye:
 * - Botón Cancelar
 * - Botón Crear/Actualizar proyecto
 *
 * **Cumple con:**
 * - P1: Componente < 200 líneas
 * - P3: Documentación JSDoc completa
 */
export function ProjectFormFooter({
  isEditMode,
  isLoading,
  onCancel,
}: ProjectFormFooterProps): JSX.Element {
  const { t } = useTranslation('projects');

  return (
    <div className="project-form-sidebar-footer">
      <div className="footer-row">
        <button
          type="button"
          onClick={onCancel}
          disabled={isLoading}
          className="btn-secondary"
        >
          {t('form.cancel')}
        </button>
        <button type="submit" form="project-form" disabled={isLoading} className="btn-primary">
          {isLoading
            ? t('form.saving')
            : isEditMode
              ? t('form.updateProject')
              : t('form.createProject')}
        </button>
      </div>
    </div>
  );
}
